import React, { FC } from 'react'

export const Icon1: FC = () => (
  <svg
    width="69"
    height="85"
    viewBox="0 0 69 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.3543 10.8936C35.5821 10.8936 36.5816 9.8958 36.5816 8.66626V2.45868C36.5816 1.22957 35.5821 0.231377 34.3543 0.231377C33.1264 0.231377 32.127 1.22957 32.127 2.45868V8.66626C32.127 9.8958 33.1264 10.8936 34.3543 10.8936Z"
      fill="#4E97EA"
    />
    <path
      d="M42.5841 12.5596C42.8688 12.6814 43.1623 12.7393 43.4514 12.7393C44.3232 12.7393 45.1468 12.2289 45.506 11.3782L47.9285 5.66838C48.4104 4.53553 47.8803 3.22571 46.7457 2.74427C45.6199 2.2659 44.3101 2.79596 43.8282 3.92574L41.4056 9.6386C40.9238 10.7719 41.4538 12.0782 42.5841 12.5596Z"
      fill="#4E97EA"
    />
    <path
      d="M23.1635 11.3789C23.5251 12.2293 24.3504 12.7397 25.2139 12.7397C25.5032 12.7397 25.8009 12.6819 26.0859 12.5598C27.2175 12.0787 27.745 10.7719 27.2685 9.63906L24.8396 3.92605C24.3546 2.79281 23.0529 2.26321 21.9214 2.74475C20.7856 3.2263 20.2581 4.53565 20.7388 5.66889L23.1635 11.3789Z"
      fill="#4E97EA"
    />
    <path
      d="M35.6543 66.5683C35.2597 66.8414 34.8024 66.992 34.3181 66.992C33.8653 66.992 33.408 66.8414 33.0134 66.5683L26.0639 61.6512L3.47998 84.2314H65.1832L42.6039 61.6512L35.6543 66.5683Z"
      fill="#262A44"
    />
    <path
      d="M0.538086 43.6225V80.7422L22.299 58.9809L0.538086 43.6225Z"
      fill="#262A44"
    />
    <path
      d="M16.5329 21.4671H52.1308V49.3589L65.7902 39.7076L56.3803 33.9719V19.3454C56.3803 18.1612 55.4111 17.2207 54.2533 17.2207H14.4059C13.2213 17.2207 12.2834 18.1612 12.2834 19.3454V33.9719L2.87354 39.7076L16.5329 49.3589V21.4671Z"
      fill="#262A44"
    />
    <path
      d="M46.3677 58.9807L68.1287 80.7422V43.6228L46.3677 58.9807Z"
      fill="#262A44"
    />
    <path
      d="M44.2473 27.7034H23.909C22.734 27.7034 21.7817 28.6535 21.7817 29.8281C21.7817 30.9996 22.734 31.9497 23.909 31.9497H44.2473C45.418 31.9497 46.3702 30.9996 46.3702 29.8281C46.3702 28.6535 45.418 27.7034 44.2473 27.7034Z"
      fill="#262A44"
    />
    <path
      d="M44.2473 37.5988H23.909C22.734 37.5988 21.7817 38.5489 21.7817 39.7235C21.7817 40.8951 22.734 41.8486 23.909 41.8486H44.2473C45.418 41.8486 46.3702 40.8951 46.3702 39.7235C46.3702 38.5489 45.418 37.5988 44.2473 37.5988Z"
      fill="#262A44"
    />
    <path
      d="M44.2473 47.4939H23.909C22.734 47.4939 21.7817 48.4439 21.7817 49.619C21.7817 50.7901 22.734 51.7437 23.909 51.7437H44.2473C45.418 51.7437 46.3702 50.7901 46.3702 49.619C46.3702 48.4439 45.418 47.4939 44.2473 47.4939Z"
      fill="#262A44"
    />
  </svg>
)
